/**
 * <article-toc>: marks the section in view in a note's table of contents.
 */

// Dependencies
import { registerComponent } from 'almostnojs';
import { Enhanced } from './enhanced.js';

/**
 * The table of contents.
 */
class ArticleToc extends Enhanced {

    /**
     * Watch the headings the links point to.
     *
     * @returns {void}
     */
    init() {

        // Links by target id.
        const links = [...this.querySelectorAll('a[href^="#"]')];
        if (!links.length || !('IntersectionObserver' in window)) return;
        const byId = new Map(links.map((a) => [decodeURIComponent(a.getAttribute('href').slice(1)), a]));

        // The heading crossing the upper part of the viewport is the current one.
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                links.forEach((a) => a.classList.remove('active'));
                byId.get(entry.target.id)?.classList.add('active');
            }
        }, { rootMargin: '-20% 0px -70% 0px' });

        // Observe.
        for (const id of byId.keys()) { const heading = document.getElementById(id); if (heading) observer.observe(heading); }
        this.own(() => observer.disconnect());
    }
}

// Register
registerComponent('article-toc', ArticleToc);
